export const getLocaleStringFromBrowserSetting = (
  supportedLocales: string[],
  defaultLocale = "en"
) => {
  const preferredLocaleList = getBrowserLocaleStringList();
  const maybeFoundPreferredLocale = preferredLocaleList.find((locale: string) =>
    getSupportedLocaleFromPreferredLocale(supportedLocales, locale)
  );
  if (maybeFoundPreferredLocale) {
    return getSupportedLocaleFromPreferredLocale(supportedLocales, maybeFoundPreferredLocale) + "";
  } else {
    return defaultLocale;
  }
};

const getBrowserLocaleStringList = (defaultLocale = "en"): readonly string[] => {
  const languageString = navigator.languages;

  // make sure userLanguage is known by typescript
  // https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/478
  interface NavigatorLanguage {
    userLanguage?: string;
  }

  if (languageString !== null && languageString && languageString.length) {
    return languageString;
  } else {
    return [navigator.language || (navigator as NavigatorLanguage).userLanguage || defaultLocale];
  }
};

// returns supported locale if found and otherwise null
const getSupportedLocaleFromPreferredLocale = (
  supportedLocales: string[],
  preferredLocale: string
) => {
  return (
    // exactmatch
    supportedLocales.find((supportedLocale) => supportedLocale === preferredLocale) ||
    // partial match: string before "-". For example: "en-GB" -> "en".
    supportedLocales.find(
      (supportedLocale) => supportedLocale === preferredLocale.split("-")[0].toLowerCase()
    ) ||
    null
  );
};
